export async function finalize (project) {
  try {
    console.log(`placeholder for validating projects`, project.id)
    return project
  } 
  catch (e) {
    console.log(`form did not validate`, e)
    throw new Error(`the form failed to validate`)
  }
}